import React, {
  CSSProperties,
  FC,
  InputHTMLAttributes,
  useEffect,
  useRef,
  FocusEventHandler,
} from "react";
import styles from "../../../../ui-kit/Typography/typography.module.css";

type FlowInputProps = {
  placeholder: string;
  value?: string;
  style?: CSSProperties;
  onChange: (value: string) => void;
  onEnter: () => void;
  onBlur?: FocusEventHandler<HTMLInputElement>;
  optionalInputProps?: Omit<
    InputHTMLAttributes<HTMLInputElement>,
    | "id"
    | "className"
    | "placeholder"
    | "style"
    | "onChange"
    | "value"
    | "enterKeyHint"
  >;
};

const FlowInput: FC<FlowInputProps> = ({
  placeholder,
  value,
  style,
  onChange,
  onEnter,
  onBlur,
  ...optionalInputProps
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const onEnterHandler = (event: HTMLElementEventMap["keydown"]) => {
      if (event.key === "Enter") {
        onEnter();
      }
    };
    inputRef.current?.addEventListener("keydown", onEnterHandler);

    return () => {
      inputRef.current?.removeEventListener("keydown", onEnterHandler);
    };
  }, [inputRef.current, onEnter]);

  return (
    <input
      tabIndex={0}
      ref={inputRef}
      className={styles.p2}
      placeholder={placeholder}
      style={{
        backgroundColor: "transparent",
        zIndex: 9,
        padding: 0,
        height: 30,
        border: "0px solid transparent",
        width: 130,
        transition: "width 300ms ease-in-out",
        ...style,
      }}
      onChange={(e) => onChange(e.target.value)}
      value={value ?? ""}
      enterKeyHint="next"
      onBlur={onBlur}
      {...optionalInputProps}
    />
  );
};

export default FlowInput;
